import { render, staticRenderFns } from "./MobAboutUs.vue?vue&type=template&id=840fdba8&scoped=true&"
import script from "./MobAboutUs.vue?vue&type=script&lang=js&"
export * from "./MobAboutUs.vue?vue&type=script&lang=js&"
import style0 from "./MobAboutUs.vue?vue&type=style&index=0&id=840fdba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840fdba8",
  null
  
)

export default component.exports